import { styled } from "@mui/material";
import { SelectElement } from "react-hook-form-mui";


export const SelectBase = styled(SelectElement)({
    fontFamily: 'Rubik',
    minWidth: '150px',
    '& > .MuiSelect-root > fieldset': {
        borderRadius: '8px',
    },
    '& > .MuiSelect-root > .MuiInputBase-input': {
        padding: '12px 16px',
    }
})